import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "./components/ui";
import Router from "./routes/Router";
import { FloatingSocials, ScrollToTop, CookieConsent } from "@/components";


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <FloatingSocials />
      <Router />
      <Toaster position="top-right" />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
